export default __webpack_public_path__ + "static/industry-contact-us-bg-f18df8fe9134a7c7a395ab4c838a17d1.jpeg";